import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker} from '@material-ui/pickers';
import styled from 'styled-components';
import useHorariosCarta from '../../Hooks/useHorariosCarta';
import db from '../../Utils/api';
import { TextField } from '@material-ui/core';

const Container = styled.div`
display:flex;
gap:10px;
justify-content:space-between;

@media (max-width: 1100px)
{
    flex-direction:column;
}
`;

const HorariosCarta = ({firebaseId}) => 
{
    const FIREBASE_ID = firebaseId.split('/')[1];
    const Horarios = useHorariosCarta(FIREBASE_ID);

    if(Horarios === undefined) 
        return (<div>Cargando</div>);


    const handleDateChange = async (e,dia,type) =>
    {
        const id = `/HorariosCarta/${firebaseId}/${dia}/${type}`;
        await db.ref(id).set(e.target.value);
    }

    return <div>
        <h4>Inicio</h4>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Container> 
                <TextField fullWidth id="time" label="Lunes" type="time"     value={Horarios?.Lunes?.start} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Lunes","start")}/>
                <TextField fullWidth id="time" label="Martes" type="time"    value={Horarios?.Martes?.start} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Martes","start")}/>
                <TextField fullWidth id="time" label="Miercoles" type="time" value={Horarios?.Miercoles?.start} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Miercoles","start")}/>
                <TextField fullWidth id="time" label="Jueves" type="time"    value={Horarios?.Jueves?.start} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Jueves","start")}/>
                <TextField fullWidth id="time" label="Viernes" type="time"   value={Horarios?.Viernes?.start} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Viernes","start")}/>
                <TextField fullWidth id="time" label="Sabado" type="time"    value={Horarios?.Sabado?.start} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Sabado","start")}/>
                <TextField fullWidth id="time" label="Domingo" type="time"   value={Horarios?.Domingo?.start} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Domingo","start")}/>
            </Container>
        </MuiPickersUtilsProvider>
        <h4>Fin</h4>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Container> 
                <TextField fullWidth id="time" label="Lunes" type="time"     value={Horarios?.Lunes?.end} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Lunes","end")}/>
                <TextField fullWidth id="time" label="Martes" type="time"    value={Horarios?.Martes?.end} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Martes","end")}/>
                <TextField fullWidth id="time" label="Miercoles" type="time" value={Horarios?.Miercoles?.end} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Miercoles","end")}/>
                <TextField fullWidth id="time" label="Jueves" type="time"    value={Horarios?.Jueves?.end} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Jueves","end")}/>
                <TextField fullWidth id="time" label="Viernes" type="time"   value={Horarios?.Viernes?.end} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Viernes","end")}/>
                <TextField fullWidth id="time" label="Sabado" type="time"    value={Horarios?.Sabado?.end} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Sabado","end")}/>
                <TextField fullWidth id="time" label="Domingo" type="time"   value={Horarios?.Domingo?.end} InputLabelProps={{ shrink: true }} inputProps={{ step: 300}}  onChange={(e) => handleDateChange(e,"Domingo","end")}/>
            </Container>
        </MuiPickersUtilsProvider>
    </div>
}

export default HorariosCarta;